import { DayOfWeek, ScheduleDetailInput } from 'generated/graphql-types';

export interface AddScheduleHourData {
   selectedDays: string[] | null;
   dayOfWeek: string | null;
   openTime: string | null;
   closeTime: string | null;
}

export interface AddScheduleHourFormData {
   scheduleDetailId: number | null;
   dayOfWeek: string | null;
   openTime: Date | null;
   closeTime: Date | null;
}

export interface ScheduleHourItemView {
   scheduleDetailId: number;
   dayOfWeek: string | null;
   openTime: Date | null;
   closeTime: Date | null;
   isDeleted: boolean;
}

export interface ScheduleHourItem {
   scheduleDetailId: number;
   dayOfWeek: DayOfWeek | null;
   openTime: Date | null;
   closeTime: Date | null;
   isDeleted: boolean;
}

export const scheduleHourFields: (keyof ScheduleDetailInput)[] = [
   'scheduleDetailId',
   'dayOfWeek',
   'openTime',
   'closeTime',
];
